"use strict";

angular
    .module("WingsUiApp.BackofficeModule")
    .controller("PartsGlobalReserveController", [
        "$state",
        "$stateParams",
        "$scope",
        "$rootScope",
        "$window",
        PartsGlobalReserveController,
    ]);
function PartsGlobalReserveController(
    $state,
    $stateParams,
    $scope,
    $rootScope,
    $window
) {
    window.scrollTo(0, 0);
}